import { Apollo } from 'src/gql/generated';

import type { ChatAssistantMessage } from '../chat-types';

/**
 * True when the durable pre-planning OCR-wait banner should show.
 * Mid-turn waits render on the tool-call card instead.
 */
export function getIsWaitingForDocumentExtraction(message: ChatAssistantMessage): boolean {
  if (message.data.documentExtractionPause?.phase !== 'prePlanning') return false;
  return (
    message.status === Apollo.AgentMessageStatus.Streaming ||
    message.status === Apollo.AgentMessageStatus.Cancelling
  );
}
